import { EMPTY_CUSTOMER_ENQUIRY_MODEL } from "presentation/model/CustomerEnquiry/CustomerEnquiryModel";
import { useState } from "react";
import { createContainer } from "react-tracked";

const {
    Provider: CustomerEnquiryProvider,
    useTracked: useCustomerEnquiryTracked
} = createContainer(() => useState(EMPTY_CUSTOMER_ENQUIRY_MODEL), {concurrentMode: true});
export { CustomerEnquiryProvider, useCustomerEnquiryTracked };
